import React, { useEffect, useState } from "react";
import { Download, ChevronDown, FileText } from "lucide-react";
import Button from "react-bootstrap/Button";
import { ButtonGroup, Spinner } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import axios from "../axios-config";

export default function DescargarDoc({
  numeroGestion,
  tipoGestion,
  titulo = "Liquidación",
}) {
  const [mostrarDropdown, setMostrarDropdown] = useState(false);
  const [archivos, setArchivos] = useState([]);
  const [loading, setLoading] = useState(true);
  const descargarArchivo = (nombre, base64) => {
    const link = document.createElement("a");
    link.href = `data:application/pdf;base64,${base64}`;
    link.download = `${nombre}`;
    link.click();
  };

  useEffect(() => {
    const fetchArchivos = async () => {
      try {
        setLoading(true);
        await axios
          .get(
            `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/getListaDocGestion?numeroGestion=${numeroGestion}&tipoGestion=${tipoGestion}`,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
              },
            }
          )
          .then((json) => {
            const data = json.data;
            setArchivos(data);
            setLoading(false);            
          });
      } catch (error) {
        console.error("Error al obtener las liquidaciones:", error);
        setArchivos([]); // si falla, deja vacío
      } finally {
      }
    };

    if (numeroGestion) {
      fetchArchivos();
    }
  }, [numeroGestion]); // se ejecuta cuando cambia el numeroGestion

  return (
    <div className="flex justify-end items-center gap-3 relative">
      {loading ? (
        <div className="flex items-center text-gray-600">
          <Spinner animation="border" size="sm" className="me-2" />
          Preparando descarga...
        </div>
      ) : (
        archivos.length > 0 && (
          <Dropdown as={ButtonGroup}>
            <Button style={{ backgroundColor: "#003479" }}>
              {" "}
              <Download size={16} className="me-2" />{titulo}
            </Button>
            <Dropdown.Toggle
              split
              id="dropdown-split-basic"
              style={{ backgroundColor: "#003479" }}
            />
            <Dropdown.Menu>
              {archivos.map((archivo, index) => (
                <Dropdown.Item
                  key={index}
                  onClick={() =>
                    descargarArchivo(archivo.nombre, archivo.base64)
                  }
                >
                  <FileText size={18} />
                  {archivo.nombre}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )
      )}
    </div>
  );
}
